<template>
  <div>
    <!-- editPayment-dialog -->
    <v-dialog v-model="editPaymentDialog" width="700" persistent>
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col cols="10">
              <h4 class="c-grey mb-0">ویرایش پرداخت</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="closeDetailsDialog()"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="نام مشتری"
                :loading="loading"
                v-model="editData.shopCustomerName"
                disabled
                hide-details
              ></v-text-field
            ></v-col>
            <v-col cols="12">
              <vuetify-money
                label="مبلغ (ریال)"
                v-model="editData.amount"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                type="number"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                attach
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="editData.paymentType"
                dense
                outlined
                hide-details
                label="نوع پرداخت"
                :items="paymentTypes"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select></v-col
            >
          </v-row>
          <v-row v-if="editData.paymentType == 'cheque'">
            <v-col cols="12">
              <v-text-field
                type="number"
                outlined
                dense
                label="شماره چک"
                v-model="editData.chequeNo"
              ></v-text-field
            ></v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="نام بانک"
                v-model="editData.chequeBank"
              ></v-text-field
            ></v-col>
            <v-col cols="12">
              <v-text-field
                v-if="editData.paymentType == 'cheque'"
                type="number"
                outlined
                dense
                label="شماره صیاد"
                :loading="loading"
                v-model="editData.chequeSayyad"
              ></v-text-field
            ></v-col>
            <v-col cols="12">
              <span v-show="false">{{ reactivity }}</span>
              <span id="chequeDate2">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-edit"
                  v-model="editData.chequeDate"
                  label="تاریخ چک"
                  :editable="true"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="editData.chequeDate"
                element="chequeDate2"
                color="#9c7fb7"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                attach
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="editData.chequeStatus"
                dense
                outlined
                hide-details
                label="وضعیت چک"
                :items="chequeStatuses"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="editData.paymentType == 'cardTransfer'">
            <v-col cols="12">
              <v-text-field
                label="شماره کارت فرستنده"
                v-model="editData.buyerCardNumber"
                outlined
                dense
                type="number"
                data-maxlength="16"
                oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
              ></v-text-field
            ></v-col>
            <v-col cols="12">
              <v-text-field
                label="شماره کارت گیرنده"
                v-model="editData.recipientCardNumber"
                outlined
                dense
                class="mb-1"
                type="number"
                data-maxlength="16"
                oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span id="date">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-edit"
                  v-model="editData.date"
                  label="تاریخ"
                  :editable="true"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="editData.date"
                element="date"
                color="#9c7fb7"
            /></v-col>
            <v-col cols="12">
              <span id="time">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-clock-time-two-outline"
                  v-model="editData.time"
                  label="ساعت"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="editData.time"
                type="time"
                element="time"
                color="#9c7fb7"
              ></date-picker
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                placeholder="توضیحات"
                outlined
                dense
                v-model="editData.description"
              ></v-textarea
            ></v-col>
          </v-row>
        </v-card-text>
        <div class="text-left py-3 pe-5">
          <v-btn
            @click="editPayment()"
            :loading="busy"
            class="purple-mainBtn"
            width="90"
            :disabled="computedBtn"
            >ثبت</v-btn
          >
          <v-btn
            class="red-borderedBtn ms-2"
            width="90"
            @click="closeDetailsDialog()"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- details-dialog -->
    <v-dialog v-model="paymentDialog" width="650" persistent>
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col cols="10" class="d-flex">
              <h4 class="c-grey">جزئیات پرداخت</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="closeDetailsDialog()"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />

        <div v-if="infoLoading" class="text-center pb-5">
          <cube></cube>
          <span style="font-size: 16px">در حال بارگذاری ...</span>
        </div>
        <div v-else>
          <v-card-text class="custom-input">
            <v-row>
              <v-col class="pt-0">
                <div
                  class="ms-auto"
                  :class="
                    payment.status == 'برگشت خورده'
                      ? 'orange-badge'
                      : 'green-badge'
                  "
                >
                  {{ payment.status }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-account-circle-outline</v-icon
                  >
                  <h5 class="purple-color font-weight-bold">نام مشتری:</h5>
                  <span class="ps-3 fs-medium" v-if="userId">
                    {{ payment.shopCustomerName }}
                  </span>
                  <a
                    v-else
                    :href="'/shop/customer/' + payment.shopCustomerId"
                    target="_blank"
                    class="ps-3 fs-medium"
                    >{{ payment.shopCustomerName }}</a
                  >
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color">mdi-cash-100</v-icon>
                  <h5 class="mb-0 purple-color font-weight-bold">مبلغ:</h5>
                  <span class="ps-3 fs-medium">
                    {{
                      Number(payment.amount).toLocaleString() + " ریال "
                    }}</span
                  >
                </h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color">mdi-cash</v-icon>
                  <h5 class="mb-0 purple-color font-weight-bold">
                    نوع پرداخت:
                  </h5>
                  <span class="ps-3 fs-medium">{{
                    paymentTypes.filter(
                      (x) => x.value == payment.paymentType
                    )[0]
                      ? paymentTypes.filter(
                          (x) => x.value == payment.paymentType
                        )[0].text
                      : "-"
                  }}</span>
                </h3>
              </v-col>
            </v-row>
            <v-row v-if="payment.paymentType == 'cheque'">
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color">mdi-checkbook</v-icon>
                  <h5 class="mb-0 purple-color font-weight-bold">شماره چک:</h5>
                  <span class="ps-3 fs-medium"> {{ payment.chequeNo }}</span>
                </h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color">mdi-bank-outline</v-icon>
                  <h5 class="mb-0 purple-color font-weight-bold">نام بانک:</h5>
                  <span class="ps-3 fs-medium">{{ payment.chequeBank }}</span>
                </h3>
              </v-col>
            </v-row>
            <v-row v-if="payment.paymentType == 'cheque'">
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color">mdi-counter</v-icon>
                  <h5 class="mb-0 purple-color font-weight-bold">
                    شماره صیاد:
                  </h5>
                  <span class="ps-3 fs-medium">
                    {{ payment.chequeSayyad }}</span
                  >
                </h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-calendar-text-outline</v-icon
                  >
                  <h5 class="mb-0 purple-color font-weight-bold">تاریخ چک:</h5>
                  <span class="ps-3 fs-medium">{{ payment.chequeDate }}</span>
                </h3>
              </v-col>
            </v-row>
            <v-row v-if="payment.paymentType == 'cheque'">
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color">mdi-cash-check</v-icon>
                  <h5 class="mb-0 purple-color font-weight-bold">وضعیت چک:</h5>
                  <span class="ps-3 fs-medium">
                    {{
                      chequeStatuses.filter(
                        (x) => x.value == payment.chequeStatus
                      )[0]
                        ? chequeStatuses.filter(
                            (x) => x.value == payment.chequeStatus
                          )[0].text
                        : "-"
                    }}</span
                  >
                </h3>
              </v-col>
            </v-row>
            <v-row v-if="payment.paymentType == 'cardTransfer'">
              <v-col cols="12">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-card-bulleted-outline</v-icon
                  >
                  <h5 class="mb-0 purple-color font-weight-bold">
                    شماره کارت فرستنده:
                  </h5>
                  <span class="ps-3 fs-medium">
                    {{ payment.buyerCardNumber }}</span
                  >
                </h3>
              </v-col>
              <v-col cols="12">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-card-bulleted-outline</v-icon
                  >
                  <h5 class="mb-0 purple-color font-weight-bold">
                    شماره کارت گیرنده:
                  </h5>
                  <span class="ps-3 fs-medium">{{
                    payment.recipientCardNumber
                  }}</span>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-calendar-text-outline</v-icon
                  >
                  <h5 class="mb-0 purple-color font-weight-bold">تاریخ:</h5>
                  <span class="ps-3 fs-medium">{{ payment.date }}</span>
                </h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-clock-time-twelve-outline</v-icon
                  >
                  <h5 class="mb-0 purple-color font-weight-bold">ساعت:</h5>
                  <span class="ps-3 fs-medium">{{ payment.time }}</span>
                </h3>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-row class="mt-0 mb-2">
              <v-col class="pt-0" cols="12">
                <h3 class="d-flex align-start">
                  <v-icon class="ml-2 purple-color"
                    >mdi-message-text-outline</v-icon
                  >
                  <h5 class="mb-0 purple-color font-weight-bold">توضیحات:</h5>
                  <span class="ps-2 fs-medium text-justify">{{
                    payment.description ? payment.description : "-"
                  }}</span>
                </h3>
              </v-col>
            </v-row>
          </v-card-text>
          <div
            class="text-left py-3 pe-5"
            v-if="payment.status != 'برگشت خورده'"
          >
            <v-btn
              @click="openEditPaymentDialog()"
              class="purple-mainBtn"
              width="90"
              >ویرایش</v-btn
            >
            <v-btn
              class="red-borderedBtn ms-2"
              width="90"
              @click="closeDetailsDialog()"
              >بازگشت</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import prices from "../mixins/prices";
// import VueBarcode from "vue-barcode";
export default {
  props: ["selectedId", "userId", "detailsDialog"],
  components: {
    datePicker: VuePersianDatetimePicker,
    // barcode: VueBarcode,
  },

  mixins: [prices],
  data: function () {
    return {
      newPaymentOpen: false,
      reactivity: false,
      isLoaded: false,
      info: [],
      loading: false,
      guide: false,
      types: ["همه", "پرداخت شده", "برگشت خورده"],
      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      excelFields: [
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "incomeId", label: "کد پرداخت" },
        { field: "amount", label: "مبلغ پرداخت شده(ریال)" },
        { field: "type", label: "نوع پرداخت" },
        { field: "status", label: "وضعیت" },
        { field: "description", label: "توضیحات" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "زمان" },
      ],
      TotalRows: "",
      codeFilter: "",
      nameFilter: "",
      typeFilter: "همه",
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      userInput: "",
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      T: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      busy: false,
      filter: null,
      selected: "",
      progress: false,
      customer: {},
      printInvoice: {},
      returnModal: false,
      paymentType: "",
      newPaymentDialog: false,
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],
      paymentsFields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "incomeId", label: "کد پرداخت" },
        { key: "amount", label: "مبلغ پرداخت شده" },
        { key: "type", label: "نوع پرداخت" },
        { key: "status", label: "وضعیت" },
        { key: "description", label: "توضیحات" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "زمان" },
        { key: "operation", label: "عملیات" },
      ],
      testData: [],
      editPaymentDialog: false,
      paymentDialog: false,
      payment: {},
      customers: [],
      gettingCustomers: false,
      newPayment: {
        customerBalance: "",
        newPaymentBalance: "",
        amount: "",
      },
      cheque: {},
      customerBalanceData: "",
      gettingBalance: false,
      editData: {},
      infoLoading: false,
    };
  },

  methods: {
    closeDetailsDialog() {
      this.paymentDialog = false;
      this.editPaymentDialog = false;
      this.$emit("closeDetailsDialog");
    },
    computedIcon(item) {
      if (item.royaltyTier == "coper") {
        return "/icons8-star-35(1).png";
      } else if (item.royaltyTier == "silver") {
        return "/icons8-star-35.png";
      } else if (item.royaltyTier == "gold") {
        return "/icons8-star-35(2).png";
      } else if (item.royaltyTier == "diamond") {
        return "/icons8-diamond-35.png";
      }
    },
    editPayment() {
      this.busy = true;
      Axios.patch(
        this.baseUrl + "/ppkpms/shop/payments/edit/" + this.selectedId,
        {
          amount: Number(this.editData.amount),
          paymentType: this.editData.paymentType,
          date: this.editData.date + " " + this.editData.time,
          description: this.editData.description,
          chequeNo:
            this.editData.paymentType == "cheque"
              ? this.editData.chequeNo
              : undefined,
          chequeBank:
            this.editData.paymentType == "cheque"
              ? this.editData.chequeBank
              : undefined,
          chequeSayyad:
            this.editData.paymentType == "cheque"
              ? this.editData.chequeSayyad
              : undefined,
          chequeDate:
            this.editData.paymentType == "cheque"
              ? this.editData.chequeDate
              : undefined,
          chequeStatus:
            this.editData.paymentType == "cheque"
              ? this.editData.chequeStatus
              : undefined,
          buyerCardNumber:
            this.editData.paymentType == "cardTransfer"
              ? Number(this.editData.buyerCardNumber)
              : undefined,
          recipientCardNumber:
            this.editData.paymentType == "cardTransfer"
              ? Number(this.editData.recipientCardNumber)
              : undefined,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            // console.log(res.data);
            this.toast(res.data.message, "success");
            this.paymentDialog = false;
            this.editPaymentDialog = false;
            this.$emit("submitEditDialog");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },
    getBalance(customerId) {
      this.purchaseDone = false;
      this.gettingBalance = true;
      this.customerBalanceData = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            // this.royaltyCreditAmount = res.data.royaltyCreditAmount;
            this.allShopIncomeBalance = res.data.allShopIncomeBalance;
            // let royaltyCreditType = res.data.royaltyCreditType;
            // this.royaltyCreditType =
            //   royaltyCreditType == "normal"
            //     ? "معمولی"
            //     : royaltyCreditType == "vip"
            //     ? "ویژه"
            //     : "فاقد اعتبار";
            this.customerBalanceData = res.data.balanceData;
            if (this.customerBalanceData > 0) {
              this.customerBalanceData =
                this.customerBalanceData.toLocaleString() + " ریال بدهکار";
            } else if (this.customerBalanceData < 0) {
              this.customerBalanceData =
                Math.abs(this.customerBalanceData).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.customerBalanceData = "تسویه";
            }
            setTimeout(() => {
              this.gettingBalance = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getCustomers() {
      this.gettingCustomers = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingCustomers = false;
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newPayment.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingCustomers = false;
          this.toast(err.response.data, "error");
        });
    },
    openEditPaymentDialog() {
      this.reactivity = !this.reactivity;
      this.paymentDialog = false;
      this.editPaymentDialog = true;
    },
    openDetailsDialog(id) {
      this.selectedId = id;
      this.detailsDialog = true;
      this.getDetailsData();
    },
    getDetailsData() {
      this.infoLoading = true;
      this.loading = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/payments/getinfo/" + this.selectedId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.infoLoading = false;

          if (res.status == 200) {
            this.payment = res.data.income;
            this.editData = this.payment;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.infoLoading = false;

          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    openPayModal() {
      this.newPaymentOpen = true;
      // this.cheque = {};
      // this.newPayment = {};
      // this.newPaymentDialog = true;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    delFilter() {
      // this.sortBy = "";
      this.userInput = "";
      // this.isBusy = true;
      // this.searchPayments();
    },
    searchPayments() {
      this.isBusy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/incomes",
        {
          shopCustomerId: this.selected,
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.testData = res.data;
            this.TotalRows = this.testData.length;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy = false;
        });
    },
  },
  computed: {
    computedInvoices() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.testData.filter((x) =>
          x.shopCustomerName.includes(this.nameFilter)
        );
      } else {
        filtered = this.testData.filter(
          (x) =>
            x.status == this.typeFilter &&
            x.shopCustomerName.includes(this.nameFilter)
        );
      }
      return filtered;
    },
    computedBtn() {
      if (this.editData.paymentType && this.editData.amount) {
        if (this.editData.paymentType == "cardTransfer") {
          if (
            !this.editData.recipientCardNumber ||
            !this.editData.buyerCardNumber
          ) {
            return true;
          } else return false;
        } else if (this.editData.paymentType == "cheque") {
          if (
            !this.editData.chequeNo ||
            !this.editData.chequeBank ||
            !this.editData.chequeDate
          ) {
            return true;
          } else return false;
        } else return false;
      } else return true;
    },
  },

  mounted() {
    this.paymentDialog = this.detailsDialog;
    this.getDetailsData();
  },
};
</script>

<style>
.v-dialog {
  overflow-y: hidden !important;
}
</style>
